export var AgencyErrorTypes;
(function (AgencyErrorTypes) {
    AgencyErrorTypes["DUPLICATE"] = "-1";
    AgencyErrorTypes["CHILDREN"] = "-14";
})(AgencyErrorTypes || (AgencyErrorTypes = {}));
